import TextArea from './textarea.comp';

export { TextArea };
export { default as useAutosizeTextAreaHeight } from './useAutosizeTextAreaHeight';
